export const QUALIFIER_CONFIG_SUCCESS = 'QUALIFIER_CONFIG_SUCCESS';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const EDI_MAPPINGS_SUCCESS = 'EDI_MAPPINGS_SUCCESS';
export const PRICE_TYPE_CONFIG_SUCCESS = 'PRICE_TYPE_CONFIG_SUCCESS';
export const PRICE_LIST_MASTER_SUCCESS = 'PRICE_LIST_MASTER_SUCCESS';
export const PRICE_LIST_MASTER_BY_ID = 'PRICE_LIST_MASTER_BY_ID';
export const PRICE_QUALIFIER_NAME_SUCCESS = 'PRICE_QUALIFIER_NAME_SUCCESS';
export const PRICE_NEW_QUALIFIER_NAME_SUCCESS =
  'PRICE_NEW_QUALIFIER_NAME_SUCCESS';
export const CUSTOM_TABLE_FIELDS_SUCCESS = 'CUSTOM_TABLE_FIELDS_SUCCESS';
export const GLOBAL_CONTRACT_CONFIG_BY_APP_TYPE = 'GLOBAL_CONTRACT_CONFIG_BY_APP_TYPE';
export const GLOBAL_CONTRACT_CONFIG_BY_CONTRACT_TYPE = 'GLOBAL_CONTRACT_CONFIG_BY_CONTRACT_TYPE';
export const PRICE_TYPE_NAME_SUCCESS = 'PRICE_TYPE_NAME_SUCCESS';
export const PRICE_LIST_DATA_BY_ID = 'PRICE_LIST_DATA_BY_ID';
export const PRICE_LIST_DATA_SUCCESS = 'PRICE_LIST_DATA_SUCCESS';
export const PRICE_MAINTENANCE_FIELDS = 'PRICE_MAINTENANCE_FIELDS';
export const PRICE_MAINTENANCE_FIELDS_NEW = 'PRICE_MAINTENANCE_FIELDS_NEW';
export const DISTINCT_PRICE_LIST_DATA = 'DISTINCT_PRICE_LIST_DATA';
export const PRICE_FORMULA_SUCCESS = 'PRICE_FORMULA_SUCCESS';
export const LIST_DATA_FORMAT_SUCCESS = 'LIST_DATA_FORMAT_SUCCESS';
export const LIST_DATA_FORMAT_BY_ID = 'LIST_DATA_FORMAT_BY_ID';
export const CONF_EDI_MAPPINGS_SUCCESS = 'CONF_EDI_MAPPINGS_SUCCESS';
export const CONF_ID_EDI_MAPPINGS_SUCCESS = 'CONF_ID_EDI_MAPPINGS_SUCCESS';
export const PRICE_CAL_FOR_LIST_SUCCESS = 'PRICE_CAL_FOR_LIST_SUCCESS';
export const PRICE_CAL_FOR_LIST_BY_ID = 'PRICE_CAL_FOR_LIST_BY_ID';
export const PRICE_CAL_FOR_LIST_BY_NAME = 'PRICE_CAL_FOR_LIST_BY_NAME';
export const PRICE_CAL_FOR_SIMULATION_SUCCESS =
  'PRICE_CAL_FOR_SIMULATION_SUCCESS';
export const PRICE_ELASTICITY = 'PRICE_ELASTICITY';
export const PRICE_SIMULATION_DATA_SUCCESS = 'PRICE_SIMULATION_DATA_SUCCESS';
export const PRICE_CATALOG_DATA_SUCCESS = 'PRICE_CATALOG_DATA_SUCCESS';
export const PRICE_SIM_RESULTS_SUCCESS = 'PRICE_SIM_RESULTS_SUCCESS';
export const LIST_DATA_UPLOAD_FAILURE = 'LIST_DATA_UPLOAD_FAILURE';
export const PRICE_POLICY_EXCEP = 'PRICE_POLICY_EXCEP';
export const DISTINCT_PROFIT_LIST_DATA = 'DISTINCT_PROFIT_LIST_DATA';
export const COMPREHENCIVE_QUOTE_DATA = 'COMPREHENCIVE_QUOTE_DATA';
export const COMPREHENCIVE_QUOTE_DATA_BY_ID = 'COMPREHENCIVE_QUOTE_DATA_BY_ID';
export const PRICE_SIMULATION_LIST_DATA = 'PRICE_SIMULATION_LIST_DATA';
export const PRICE_SIMULATION_DATA_BY_ID = 'PRICE_SIMULATION_DATA_BY_ID';
export const PRICE_CATALOG_LIST_DATA = 'PRICE_CATALOG_LIST_DATA';
export const PRICE_MAINTENANCE_FIELDS_BY_PRICE_TYPE =
  'PRICE_MAINTENANCE_FIELDS_BY_PRICE_TYPE';
export const PRICE_LIST_DATA_MESSAGELOG = 'PRICE_LIST_DATA_MESSAGELOG';
export const PRICE_UNIQUE_SUCCESS = 'PRICE_UNIQUE_SUCCESS';
export const PRICE_FILTER_DATA = 'PRICE_FILTER_DATA';
export const CATALOG_FILTER_DATA = 'CATALOG_FILTER_DATA';
export const PRICE_CATALOG_SUCCESS = 'PRICE_CATALOG_SUCCESS';
export const PRICE_ADJUST_SUCCESS = 'PRICE_ADJUST_SUCCESS';
export const PRICE_REQUEST_CONFIG_SUCCESS = 'PRICE_REQUEST_CONFIG_SUCCESS';
export const PRICE_SIMULATION_CONFIG_BY_ID = 'PRICE_SIMULATION_CONFIG_BY_ID';
export const PRICE_SIMULATION_CONFIG_SUCCESS = 'PRICE_SIMULATION_CONFIG_SUCCESS';
export const PRICE_CATALOG_CONFIG_SUCCESS = 'PRICE_CATALOG_CONFIG_SUCCESS';
export const PRICE_CATALOG_CONFIG_BY_ID = 'PRICE_CATALOG_CONFIG_BY_ID';
export const PRICE_REASON_CODE_CONFIG_SUCCESS =
  'PRICE_REASON_CODE_CONFIG_SUCCESS';
export const PRICE_CONTRACT_ID = 'PRICE_CONTRACT_ID';
export const PRICE_CONTRACTS_LIST = 'PRICE_CONTRACTS_LIST';
export const PRICE_REQUESTS_LIST_SUCCESS = 'PRICE_REQUESTS_LIST_SUCCESS';
export const PRICE_REQUESTS_LIST_ID_SUCCESS = 'PRICE_REQUESTS_LIST_ID_SUCCESS';
export const PRICE_REQUESTS_SUCCESS = 'PRICE_REQUESTS_SUCCESS';
export const PRICE_REQUESTS_BY_ID_SUCCESS = 'PRICE_REQUESTS_BY_ID_SUCCESS';
export const RESET_PRICE_LIST_DATA = 'RESET_PRICE_LIST_DATA';
export const RESET_PRICE_MAINTENANCE_FIELDS = 'RESET_PRICE_MAINTENANCE_FIELDS';
export const PRICE_CONTRACTS = 'PRICE_CONTRACTS';
export const PRICE_CONTRACT_APPROVAL = 'PRICE_CONTRACT_APPROVAL';
export const PRICE_PROFILE_SELECTION_SUCCESS =
  'PRICE_PROFILE_SELECTION_SUCCESS';
export const QUOTE_CONFIGURATION_SUCCESS = 'QUOTE_CONFIGURATION_SUCCESS';
export const CLEAR_QUOTE_CONFIGURATION = 'CLEAR_QUOTE_CONFIGURATION';
export const LAYOUT_DATA_SUCCESS = 'LAYOUT_DATA_SUCCESS';
export const PRICE_PROFILE_SELECTION_BY_ID = 'PRICE_PROFILE_SELECTION_BY_ID';
export const PRICE_PROFILE_SELECTION_ATTRIBUTES =
  'PRICE_PROFILE_SELECTION_ATTRIBUTES';
export const PRICE_CONTRACT_FIELDS = 'PRICE_CONTRACT_FIELDS';
export const PRICE_WORKFLOW_NAME_SUCCESS = 'PRICE_WORKFLOW_NAME_SUCCESS';
export const PRICE_WORKFLOW_STATUS_SUCCESS = 'PRICE_WORKFLOW_STATUS_SUCCESS';
export const PRICE_WORKFLOW_NEXT_STATUS_SUCCESS =
  'PRICE_WORKFLOW_NEXT_STATUS_SUCCESS';
export const CLEAR_WORKFLOW_STATUS_DATA = 'CLEAR_WORKFLOW_STATUS_DATA';
export const WORKFLOW_STATUS = 'WORKFLOW_STATUS';
export const PRICE_LAYOUT_SUCCESS = 'PRICE_LAYOUT_SUCCESS';
export const PRICE_LAYOUT_BY_ID_SUCCESS = 'PRICE_LAYOUT_BY_ID_SUCCESS';
export const PRICE_PROFILE_CONFIGURATION_SUCCESS =
  'PRICE_PROFILE_CONFIGURATION_SUCCESS';
export const PRICE_PROFILE_CONFIGURATION_BY_ID =
  'PRICE_PROFILE_CONFIGURATION_BY_ID';
export const PRICE_LAYOUT_BY_QUOTE_SUCCESS = 'PRICE_LAYOUT_BY_QUOTE_SUCCESS';
export const PRICE_LAYOUT_BY_DOCUMENT_SUCCESS = 'PRICE_LAYOUT_BY_DOCUMENT_SUCCESS';
export const PRICE_POINTS_SUCCESS = 'PRICE_POINTS_SUCCESS';
export const PRICE_HISTORY_SUCCESS = 'PRICE_HISTORY_SUCCESS';
export const PRICE_HISTORY_BY_ID_SUCCESS = 'PRICE_HISTORY_BY_ID_SUCCESS';
export const PRICE_POINTS_BY_ID = 'PRICE_POINTS_BY_ID';
export const PRICE_POINTS_BY_NAME = 'PRICE_POINTS_BY_NAME';
export const DELETE_PRICE_POINT_SUCCESS = 'DELETE_PRICE_POINT_SUCCESS';
export const DELETE_PRICE_POINT_ERROR = 'DELETE_PRICE_POINT_ERROR';
export const PRICE_POINT_EXECUTE_SUCCESS = 'PRICE_POINT_EXECUTE_SUCCESS';
export const PRICE_POINT_EXECUTE_ERROR = 'PRICE_POINT_EXECUTE_ERROR';
export const CLEAR_PRICE_POINT_EXECUTE_RESULT = 'CLEAR_PRICE_POINT_EXECUTE_RESULT';
export const PRICE_LIST_CONFIG = 'PRICE_LIST_CONFIG';
export const SET_SELECTED_PRICE_LIST_BY_RULE = 'SET_SELECTED_PRICE_LIST_BY_RULE';
export const SET_UNSAVED_PRICE_CHANGES = 'SET_UNSAVED_PRICE_CHANGES';
export const CLEAR_UNSAVED_PRICE_CHANGES = 'CLEAR_UNSAVED_PRICE_CHANGES';
